import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styles: [
    ':host {@apply inline-block}'
  ]
})
export class SpinnerComponent {

  readonly strokeWidth = input<number | string>(3);

}
